export const SERVICE_TYPES = {
  WATER_BOTTLE: 'Water Bottle',
  ROOM_CLEANING: 'Room Cleaning',
  EXTRA_TOWEL: 'Extra Towel',
  LAUNDRY_PICKUP: 'Laundry Pickup',
  FOOD_ORDER: 'Food Order',
  MAINTENANCE_REQUEST: 'Maintenance Request',
  CUSTOM_REQUEST: 'Custom Request'
};

export const REQUEST_STATUS = {
  PENDING: 'Pending',
  ACCEPTED: 'Accepted',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled'
};

export const HOTEL_LOCATIONS = {
  KATHMANDU: 'Kathmandu',
  POKHARA: 'Pokhara',
  CHITWAN: 'Chitwan'
};

export const HOTEL_CATEGORIES = {
  LUXURY: 'luxury',
  MID_RANGE: 'mid-range',
  BUDGET: 'budget'
};

export const PRICE_TIERS = {
  BUDGET: 'Budget',
  MODERATE: 'Moderate',
  PREMIUM: 'Premium',
  LUXURY: 'Luxury'
};

export const ACTIVITY_CATEGORIES = {
  ADVENTURE: 'Adventure',
  CULTURAL: 'Cultural',
  NATURE: 'Nature',
  DINING: 'Dining',
  WELLNESS: 'Wellness'
};

export const ROOM_STATUS = {
  AVAILABLE: 'Available',
  OCCUPIED: 'Occupied',
  CLEANING: 'Cleaning',
  MAINTENANCE: 'Maintenance'
};
